import type { FC } from 'react';
import { lazy } from 'react';
import { useDocumentExchangeRoot } from 'src/apis/document-exchange/use-document-exchange-root';
import { PageSpinner } from 'src/components/spinner-container';
import { Forbidden } from 'src/utils/errors';

const Page = lazy(() => import('./page'));

export const OperatorDocuments: FC = () => {
  const documentExchange = useDocumentExchangeRoot();

  if (!documentExchange.response) {
    return <PageSpinner />;
  }

  if (!documentExchange.response?.data._links.getOperatorDocumentsInbox) {
    throw new Forbidden();
  }

  return <Page documentExchange={documentExchange} />;
};
